import FeaturesContainer from './FeaturesContainer'

const PlaceAlerts = ({ history }) => {
    return <FeaturesContainer history={history} pageName={'place_alerts'} nextUrl={'check-in'} pageEvent={'onboardingPlaceAlerts'} clickEvent={'onboardingPlaceAlertsSubmitted'} />
};

export default PlaceAlerts
